var exports = {
  "k": "xe7b6e3d6--2c156f--container",
};

module.exports = exports;
